import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5.75 12V18.25H12M12 5.75H18.25V12" vectorEffect="non-scaling-stroke" />
	</SVG>
);
